import classNames from 'classnames'
import {tailwindClassesName} from 'definitions/constant'
import {ReactNode, FC} from 'react'
import {Helmet} from 'react-helmet'

export const MainLayout: FC<{
  children: ReactNode[] | ReactNode
  classes?: string
}> = ({children, classes}) => {
  return (
    <>
      <Helmet>Dope Security</Helmet>
      {/* This hidden element added for tailwind CSS classes which are being used on run time 
      These classes should be available on final prod build
      */}
      <p hidden className={classNames(tailwindClassesName)} />
      <div
        id="main-layout"
        data-cy="main-layout"
        className={`flex flex-col h-screen w-screen overflow-hidden ${classes}`}
      >
        {children}
      </div>
    </>
  )
}
